<template>
  <div :class="$style.page">
    <Title title="我的认证"></Title>

    <Row>
      <div :class="$style.certify" v-for="(item, index) in list" :key="index">
        <img :class="$style.img" :src="item.img" alt="" />
        <div :class="$style.info">
          <div :class="$style.number">{{ item.text }}</div>
          <div :class="$style.btn" @click="toDetail(item.link)">查看</div>
        </div>
      </div>
    </Row>
  </div>
</template>

<script>
import { getCertifyCount } from "@server";

export default {
  name: "CertifyCation",
  data() {
    return {
      countInfo: {
        identityCount: 0,
        enterpriseCount: 0,
        emailCount: 0,
      },
    };
  },
  computed: {
    list() {
      return [
        {
          img: require("@assets/image/certify_email.png"),
          text: `邮箱认证 （${this.countInfo.emailCount}）`,
          link: "/user/certify-email",
        },
        {
          img: require("@assets/image/certify_personal.png"),
          text: `个人认证 （${this.countInfo.identificationCount}）`,
          link: "/user/certify-user",
        },
        {
          img: require("@assets/image/certify_company.png"),
          text: `企业认证 （${this.countInfo.companyCount}）`,
          link: "/user/certify-company",
        },
      ];
    },
  },
  methods: {
    async getCertifyCount() {
      const res = await getCertifyCount();
      const { code, data } = res;

      if (code === 200) {
        this.countInfo = data;
      }
    },

    toDetail(link) {
      this.$router.push(link);
    },
  },
  created() {
    this.getCertifyCount();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: rem(600);
  padding: rem(50);
  padding-top: 0;
  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  .certify {
    width: rem(410);
    padding: rem(56);
    margin-right: rem(50);
    border: $border-1;
    box-shadow: $box-shadow;
    @include flex();

    .img {
      height: rem(70);
      min-height: 50px;
      margin-right: 20px;
      object-fit: cover;
    }

    .info {
      align-self: stretch;
      height: rem(70);
      min-height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .number {
      font-size: max(rem(16), 14px);
      font-weight: bold;
      color: #000;
    }

    .btn {
      width: rem(80);
      height: rem(34);
      font-size: rem(14);
      color: $theme-color;
      line-height: rem(34);
      text-align: center;
      border-radius: rem(18);
      border: $border-1;
      cursor: pointer;

      &:hover {
        border-color: $theme-color;
      }
    }
  }
}
</style>
